import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NxIconModule } from '@allianz/ng-aquila/icon';
import { NxLinkModule } from '@allianz/ng-aquila/link';
import { NxIndicatorModule } from '@allianz/ng-aquila/indicator';
import { LinkComponent } from './link.component';

@NgModule({
  exports: [LinkComponent],
  imports: [CommonModule, NxIconModule, NxLinkModule, NxIndicatorModule, LinkComponent],
})
export class LinkModule {}
